__turbopack_context__.v({
  "spinner": "loader-module-scss-module__EpEwTq__spinner",
  "spinnerWrapper": "loader-module-scss-module__EpEwTq__spinnerWrapper",
  "spinning": "loader-module-scss-module__EpEwTq__spinning",
  "text": "loader-module-scss-module__EpEwTq__text",
});
